import React from 'react';
import { SourceListItem } from './source_list_item';

const SourceList = ({ sources, openSourceIndices, handleSourceClick, messageId }) => {
  const filteredSources = sources;

  return (
    <div className="mt-4">
      <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">Sources:</p>
      <ol className="mt-2 space-y-2">
        {filteredSources.map((source, index) => {
          const sourceNumber = index + 1;
          return (
            <SourceListItem
              key={index}
              source={source}
              sourceNumber={sourceNumber}
              isOpen={openSourceIndices.has(sourceNumber)}
              onClick={handleSourceClick}
              messageId={messageId}
            />
          );
        })}
      </ol>
    </div>
  );
};

export { SourceList };
